import React,{useEffect} from 'react'
import { useParams } from 'react-router';

const API = 'https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=9e6cb54fb7368ab503a406230cc63f3a&page=1';
const IMGPATH = "https://image.tmdb.org/t/p/w1280";
const SEARCHAPI ="https://api.themoviedb.org/3/search/movie?&api_key=9e6cb54fb7368ab503a406230cc63f3a&query=";


const FINDAPI = 'https://api.themoviedb.org/3/movie/'
const KEY = '?api_key=9e6cb54fb7368ab503a406230cc63f3a&language=en-US'

const MovieDB = () => {
    const {id} = useParams()
    const [singleMovie,setSingleMovie] = React.useState([])

    const fetchSingleMovie =  async() =>{
        const resp = await fetch(`${FINDAPI}${id}${KEY}`)
        const data = await resp.json()
        console.log(data);
        // console.log(data.results);
        const {backdrop_path:background_img,
            title,
            original_language:language,
            overview,
            popularity,
            poster_path,
            release_date:release,
            runtime,
            vote_average,
            vote_count} = data
        const genresList = data.genres.map((item)=>{
            const newId = new Date().getTime().toString()
            return [item.name,newId]
        })
        const newData = [{background_img,title,language,overview,popularity,release,runtime,vote_average,vote_count,poster_path,genresList}]
        console.log(newData[0].genresList);
        setSingleMovie(newData)
    }
    
    
    useEffect(()=>{
        fetchSingleMovie()
    },[id])
    
    return (
        <>
        {singleMovie.map((item)=>{
            const {title,background_img,language,overview,popularity,release,runtime,vote_average,vote_count,poster_path} = item
            return (
                    <div key={id} className="moviedb_container" style={{backgroundImage:`linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url(${IMGPATH+background_img})`}}>
                        <div className="moviedb_main">
                            <div className="moviedb_img">
                                <img src={IMGPATH+poster_path} alt="" />
                            </div>
                            <div className="moviedb_info">
                                <h3>{title}   <span>({release.substring(0,4)}) - {language.toUpperCase()}</span></h3> 
                                <div className="moviedb_rating">
                                    <p className='rating_bar'>Rating: {vote_average}</p>
                                    <p className='rating_bar'>User Score: {vote_count}</p>
                                    <p className='rating_bar'>Popularity: {popularity.toFixed(0)}</p>
                                    <p className='rating_bar'>Runtime: {runtime}</p>
                                </div>
                                <div className="row">
                                {item.genresList.map((list)=>{
                                    return <p key={list} className='rating_bar'>{list[0]}</p>
                                })}
                                </div>
                                <div className="release_data">
                                    <p>Release Date: {release}</p>
                                </div>
                                <div className="overview_data">
                                    <div>
                                        <h3>Overview:</h3>
                                        <div className='overview_text'>{overview}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            )
        })}
        </>
    )
}

export default MovieDB
